module.exports = __webpack_public_path__ + "static/media/medication_slider_phone3.7619efaa.png";